import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

import SimPopupWithDiscount from 'components/SimPopupWithDiscount';
import useMediaSizes from 'hooks/useMediaSizes';
import { SimSlider, SimSliderContainer } from 'components/SimSlider';

const videoList = [
	{
		thumb: 'tn1',
		link: 'https://www.youtube.com/embed/aRiZ2m_Capk'
	},
	{
		thumb: 'tn2',
		link: 'https://www.youtube.com/embed/M5i5c9kNbOQ'
	},
	{
		thumb: 'tn3',
		link: 'https://www.youtube.com/embed/BwwXyiAGCMM'
	},
	{
		thumb: 'tn4',
		link: 'https://www.youtube.com/embed/mQcWxpTDW8s'
	}
];

const SpeechLangTherapyVideoScroll = () => {
	const theme = useTheme();
	const [isXs, isSm, isMd] = useMediaSizes();

	return (
		<Box
			paddingBottom={0}
			display={'flex'}
			flexDirection={'row'}
			alignItems={'center'}
			alignContent={'center'}
			justifyContent={'center'}
			bgcolor={'transparent'}
			marginY={0}
			paddingY={0}
			sx={{
				position: 'relative',
				boxShadow: 0,
				paddingBottom: 0
			}}>
			<Box position={'relative'} zIndex={2}>
				<Box marginTop={4} marginBottom={0}>
					<SimTypography
						sx={{
							textTransform: 'uppercase',
							fontWeight: 'medium'
						}}
						gutterBottom
						color={'secondary'}
						align={'left'}
						paddingLeft='2vw'>
						FEATURED SERVICE RESOURCES
					</SimTypography>
					<SimTypography
						variant='h4'
						align={'left'}
						paddingLeft='2vw'
						sx={{
							fontWeight: 700,
							marginTop: theme.spacing(1)
						}}>
						Our recommended videos
					</SimTypography>
				</Box>

				<SimSliderContainer
					maxWidth={'70vw'}
					slideProps={{ marginX: 'auto', paddingX: 'auto', marginY: 0, paddingY: 0 }}>
					<SimSlider
						options={{
							speed: 1000,
							slidesToShow: isSm || isMd ? 3 : isXs ? 1 : 1,
							autoplaySpeed: 3000
						}}>
						{videoList.map((item, i) => (
							<Box>
								<SimPopupWithDiscount index={i} srcLink={item.link} />
							</Box>
						))}
					</SimSlider>
				</SimSliderContainer>
			</Box>
		</Box>
	);
};

export { SpeechLangTherapyVideoScroll };
